<template>
  <div class="pop-up-wrap-user">
    <div class="pop-up-user pop-customer">
      <div class="pop-header-user">
        <span class="title02">객층관리</span>
        <button class="btn-pop-close" id="btnClosePopup" @click="close()">
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-body">
        <div class="select-area">
          <div class="btn-group">
            <span class="h2">객층1</span>
            <div class="flex2">
              <button
                class="btn-radio"
                :class="{ 'selected-radio': selectCust1 == 'M' }"
                id=""
                @click="selectCust1 = 'M'"
              >
                남성<span class="overlay"></span>
              </button>
              <button
                class="btn-radio"
                :class="{ 'selected-radio': selectCust1 == 'W' }"
                id=""
                @click="selectCust1 = 'W'"
              >
                여성<span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                +추가<span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                <span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                <span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                <span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                <span class="overlay"></span>
              </button>
              <!-- <button class="btn-radio" id=""><span class="overlay"></span></button> -->
            </div>
          </div>

          <div class="btn-group">
            <span class="h2">객층2</span>
            <div class="flex2">
              <button
                class="btn-radio"
                id=""
                :class="{ 'selected-radio': selectCust2 == 'C001' }"
                @click="selectCust2 = 'C001'"
              >
                10대<span class="overlay"></span>
              </button>
              <button
                class="btn-radio"
                id=""
                :class="{ 'selected-radio': selectCust2 == 'C002' }"
                @click="selectCust2 = 'C002'"
              >
                20대<span class="overlay"></span>
              </button>
              <button
                class="btn-radio"
                id=""
                :class="{ 'selected-radio': selectCust2 == 'C003' }"
                @click="selectCust2 = 'C003'"
              >
                30대<span class="overlay"></span>
              </button>
              <button
                class="btn-radio"
                id=""
                :class="{ 'selected-radio': selectCust2 == 'C004' }"
                @click="selectCust2 = 'C004'"
              >
                40대<span class="overlay"></span>
              </button>
              <button
                class="btn-radio"
                id=""
                :class="{ 'selected-radio': selectCust2 == 'C005' }"
                @click="selectCust2 = 'C005'"
              >
                50대<span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                <span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                <span class="overlay"></span>
              </button>
              <button class="btn-radio" id="">
                <span class="overlay"></span>
              </button>
            </div>
          </div>

          <div class="table-wrap">
            <table class="tb-comm customer">
              <caption>
                반품사유
              </caption>
              <thead>
                <tr>
                  <td>No</td>
                  <td>객층1</td>
                  <td>객층2</td>
                  <td>객수</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(customer, i) in selectCustomerList"
                  :key="customer"
                  @click="selectIdx = customer.idx"
                  :class="{ on: selectIdx == customer.idx }"
                >
                  <td>{{ lpad(i + 1, 3, "0") }}</td>
                  <td>{{ customer.cust1 == "W" ? "여성" : "남성" }}</td>
                  <td v-if="customer.cust2 == 'C001'">10대</td>
                  <td v-else-if="customer.cust2 == 'C002'">20대</td>
                  <td v-else-if="customer.cust2 == 'C003'">30대</td>
                  <td v-else-if="customer.cust2 == 'C004'">40대</td>
                  <td v-else>50대</td>
                  <td>{{ customer.custNum }}</td>
                </tr>
              </tbody>
            </table>
            <div class="btn-arr-area portrait">
              <button class="btn-up btn-up-2">
                <span class="overlay"></span>
              </button>
              <button class="btn-down btn-down-2" disabled>
                <span class="overlay"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="pop-keypad-wrap-user">
          <div class="pop-keypad-area-user">
            <div class="ip-row">
              <input
                type="text"
                id="ipKeypad"
                name=""
                class="ip-keypad has-btn left"
                placeholder="내용을 입력하세요"
                :value="keypadData"
                readonly
              />
              <button
                type="button"
                class="btn-md2 btn-skyblue"
                @click="custNumChange()"
              >
                객수<br />변경<span class="overlay"></span>
              </button>
            </div>

            <div class="bg-box-dark">
              <div class="keypad02">
                <button type="button" @click="setKeypad(1)">
                  1<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(2)">
                  2<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(3)">
                  3<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(4)">
                  4<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(5)">
                  5<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(6)">
                  6<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(7)">
                  7<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(8)">
                  8<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad(9)">
                  9<span class="overlay"></span>
                </button>
                <button type="button" class="r2c1" @click="setKeypad(0)">
                  0<span class="overlay"></span>
                </button>
                <button type="button" @click="setKeypad('00')">
                  00<span class="overlay"></span>
                </button>
              </div>
              <div class="keypad-side">
                <button type="button" class="btn-c" @click="setKeypad(10)">
                  C<span class="overlay"></span>
                </button>
                <button type="button" class="btn-del" @click="setKeypad(-1)">
                  <span class="overlay"></span>
                </button>
                <button type="button" class="btn-enter" @click="setKeypad('E')">
                  <span class="overlay"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pop-btn-area2">
        <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
        <button
          type="button"
          class="btn-pop-lg btn-main"
          :disabled="selectIdx == 0"
          @click="selectDelete()"
        >
          선택취소<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-pop-lg btn-main"
          :disabled="selectCustomerList.length == 0"
          @click="selectCustomerList = []"
        >
          전체취소<span class="overlay"></span>
        </button>
        <button
          type="button"
          :disabled="selectCustomerList.length == 0"
          class="btn-pop-lg btn-half btn-submit"
          @click="$.emit('tableSetBaskets', selectCustomerList)"
        >
          입력완료<span class="overlay"></span>
        </button>
      </div>
    </div>
    <div class="dimed"></div>
  </div>
</template>

<script>
export default {
  name: "customerManagement",
  props: {},
  data() {
    return {
      selectCustomerList: [],
      selectCust1: "",
      selectCust2: "",
      keypadData: "",
      selectIdx: 0,
    };
  },
  methods: {
    selectDelete() {
      let filteredArray = this.selectCustomerList.filter(
        (item) => item.idx != this.selectIdx
      );
      this.selectCustomerList = filteredArray;
      this.selectIdx = 0;
    },
    complete() {
      let idx =
        this.selectCustomerList.length == 0
          ? 0
          : Math.max(...this.selectCustomerList.map((item) => item.idx));
      this.selectCustomerList.push({
        idx: ++idx,
        cust1: this.selectCust1,
        cust2: this.selectCust2,
        custNum: 1,
      });

      (this.selectCust1 = ""), (this.selectCust2 = ""), (this.keypadData = "");
    },
    setKeypad(str) {
      if (str == "E") {
        this.custNumChange();
      } else if (str < 0) {
        this.keypadData = this.keypadData.slice(0, -1);
      } else if (str == 10) {
        this.keypadData = "";
      } else {
        this.keypadData += String(str) + "";
      }
    },
    lpad(str, padLen, padStr) {
      if (padStr.length > padLen) {
        return str;
      }
      str += "";
      padStr += "";
      while (str.length < padLen) str = padStr + str;
      str = str.length >= padLen ? str.substring(0, padLen) : str;
      return str;
    },
    custNumChange() {
      if (this.selectIdx == 0) return;
      if (Number(this.keypadData) == 0) return;
      this.selectCustomerList.filter(
        (item) => item.idx == this.selectIdx
      )[0].custNum = Number(this.keypadData);
      this.keypadData = "";
    },
    close() {
      if (this.selectCustomerList.length == 0) {
        this.selectCustomerList.push({
          idx: 1,
          cust1: this.selectCust1 == "" ? "M" : this.selectCust1,
          cust2: this.selectCust2 == "" ? "C001" : this.selectCust2,
          custNum: 1,
        });
      }
      this.$.emit("tableSetBaskets", this.selectCustomerList);
    },
  },
  watch: {
    selectCust1: function (val) {
      if (this.selectCust2 != "" && val != "") this.complete();
    },
    selectCust2: function (val) {
      if (this.selectCust1 != "" && val != "") this.complete();
    },
  },
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


